import { render, staticRenderFns } from "./SalesResender.vue?vue&type=template&id=2b664bf2&"
import script from "./SalesResender.vue?vue&type=script&lang=js&"
export * from "./SalesResender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports